import { Controller } from '@hotwired/stimulus';

export default class NumberInputController extends Controller {
    static targets = [
        'input',
    ];

    min = null;
    max = null;

    get value() {
        return parseInt(this.inputTarget.value || 0);
    }

    set value(value) {
        this.inputTarget.value = value;
    }

    connect() {
        this.min = this.inputTarget.min || null;
        this.max = this.inputTarget.max || null;
    }

    increase() {
        const current = this.value;

        if (this.max === null || current + 1 <= this.max) {
            this.value = current + 1;
        }
    }

    decrease() {
        const current = this.value;

        if (this.min === null || current - 1 >= this.min) {
            this.value = current - 1;
        }
    }
}
